export const paymentsAccountHandler = {
    pathPattern: '/brands/:brandId/billing/disputes/:disputeId',
    toWeb: ({ brandId, disputeId }) => ({
        path: `/brands/${brandId}/billing/disputes/${disputeId}`,
    }),
    meta: {
        title: 'Payments dispute / payout',
        description: 'Opens a payments-account dispute or payout detail.',
        status: 'live',
        platforms: { web: true, ios: false, android: false },
        flag: null,
        params: [
            { name: 'brandId', in: 'path', required: true },
            { name: 'disputeId', in: 'path', required: true },
        ],
        example: {
            params: { brandId: 'BXqExampleBrandId', disputeId: 'exampleDisputeId' },
        },
    },
};
//# sourceMappingURL=payments-account.js.map